// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   SuggestDropdown — autocomplete dropdown
   ============================================ */

.grb-widget--suggest {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: var(--grb-color-background);
  border-bottom: 1px solid var(--grb-color-border);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  display: none;
  flex-direction: column;
  max-height: 320px;
  overflow-y: auto;
  z-index: 1;
}

.grb-widget--suggest.grb-widget--visible,
.grb-widget--suggest.grb-widget--suggest-visible {
  display: flex;
}

.grb-widget--suggest-item {
  display: flex;
  align-items: center;
  gap: var(--grb-spacing-sm);
  padding: 10px var(--grb-spacing-md);
  cursor: pointer;
  transition: background-color 0.1s ease;
  border-bottom: 1px solid var(--grb-color-border-light);
}

.grb-widget--suggest-item:last-child {
  border-bottom: none;
}

.grb-widget--suggest-item:hover,
.grb-widget--suggest-item.grb-widget--active {
  background-color: var(--grb-color-background-secondary);
}

.grb-widget--suggest-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.grb-widget--suggest-icon svg {
  width: 14px;
  height: 14px;
  stroke: var(--grb-color-text-secondary);
  fill: none;
}

.grb-widget--suggest-text {
  flex: 1;
  font-size: var(--grb-font-size-base);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Group header */
.grb-widget--suggest-group {
  padding: 8px var(--grb-spacing-md) 4px;
  font-size: var(--grb-font-size-xs);
  color: var(--grb-color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

/* Active (keyboard nav) */
.grb-widget--suggest-item.grb-widget--suggest-item-active {
  background-color: var(--grb-color-background-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/styles/suggest.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,uCAAuC;EACvC,gDAAgD;EAChD,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,mCAAmC;EACnC,eAAe;EACf,sCAAsC;EACtC,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,sCAAsC;EACtC,kCAAkC;EAClC,sCAAsC;EACtC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,uDAAuD;AACzD","sourcesContent":["/* ============================================\n   SuggestDropdown — autocomplete dropdown\n   ============================================ */\n\n.grb-widget--suggest {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: var(--grb-color-background);\n  border-bottom: 1px solid var(--grb-color-border);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n  display: none;\n  flex-direction: column;\n  max-height: 320px;\n  overflow-y: auto;\n  z-index: 1;\n}\n\n.grb-widget--suggest.grb-widget--visible,\n.grb-widget--suggest.grb-widget--suggest-visible {\n  display: flex;\n}\n\n.grb-widget--suggest-item {\n  display: flex;\n  align-items: center;\n  gap: var(--grb-spacing-sm);\n  padding: 10px var(--grb-spacing-md);\n  cursor: pointer;\n  transition: background-color 0.1s ease;\n  border-bottom: 1px solid var(--grb-color-border-light);\n}\n\n.grb-widget--suggest-item:last-child {\n  border-bottom: none;\n}\n\n.grb-widget--suggest-item:hover,\n.grb-widget--suggest-item.grb-widget--active {\n  background-color: var(--grb-color-background-secondary);\n}\n\n.grb-widget--suggest-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n.grb-widget--suggest-icon svg {\n  width: 14px;\n  height: 14px;\n  stroke: var(--grb-color-text-secondary);\n  fill: none;\n}\n\n.grb-widget--suggest-text {\n  flex: 1;\n  font-size: var(--grb-font-size-base);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Group header */\n.grb-widget--suggest-group {\n  padding: 8px var(--grb-spacing-md) 4px;\n  font-size: var(--grb-font-size-xs);\n  color: var(--grb-color-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n/* Active (keyboard nav) */\n.grb-widget--suggest-item.grb-widget--suggest-item-active {\n  background-color: var(--grb-color-background-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
